import { BoxIcon } from "@xola/icons";
import React from "react";
import { Merchandise } from "types";
import { ProductImage } from "@/components/Common/ProductImage";

interface ProductInfoHeaderProps {
    merchandise: Merchandise;
    variantName: string;
    variantPath?: string;
    hasVariants?: boolean;
    sku?: string;
}

export const ProductInfoHeader = ({
    merchandise,
    variantName,
    variantPath,
    hasVariants,
    sku,
}: ProductInfoHeaderProps) => (
    <div className="flex space-x-4">
        <ProductImage product={merchandise} size="medium" />
        <div className="flex-1">
            <h5 className="font-bold">{variantName}</h5>
            {variantPath && (
                <div className="mt-1 flex items-center text-gray-dark">
                    <BoxIcon size="small" />
                    <p className="ml-1">{variantPath}</p>
                </div>
            )}
            {hasVariants && <p className="mt-1">{sku ?? "No SKU"}</p>}
        </div>
    </div>
);
